import React, { Component } from 'react';
import { withRouter } from 'react-router';

class FacturaSearch extends Component {

  componentDidMount() {
    this.props.history.push('/home/factura/search');
  }

  render() {
    return null;
  }
}

export default withRouter(FacturaSearch);